import React from 'react';
import { MailIcon, LinkedinIcon } from 'lucide-react';
export function Contact() {
  return <div className="w-full max-w-4xl mx-auto px-6 py-12" data-id="element-66">
      <h2 className="text-4xl font-bold text-gray-900 mb-4 text-center" data-id="element-67">
        Get In Touch
      </h2>
      <p className="text-gray-600 text-center mb-12" data-id="element-68">
        Feel free to reach out through any of the following channels.
      </p>
      <div className="bg-white rounded-lg shadow-md p-12 max-w-2xl mx-auto" data-id="element-69">
        <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center" data-id="element-70">
          Contact Information
        </h3>
        <div className="space-y-6" data-id="element-71">
          <div className="flex items-center gap-4 justify-center" data-id="element-72">
            <MailIcon className="text-blue-600" size={24} data-id="element-73" />
            <div className="text-center" data-id="element-74">
              <p className="font-semibold text-gray-900 text-lg mb-1" data-id="element-75">Email</p>
              <a href="mailto:jake.j3.jackson@gmail.com" className="text-blue-600 hover:underline text-lg" data-id="element-76">
                jake.j3.jackson@gmail.com
              </a>
            </div>
          </div>
          <div className="border-t pt-6" data-id="element-77">
            <div className="flex items-center gap-4 justify-center" data-id="element-78">
              <LinkedinIcon className="text-blue-600" size={24} data-id="element-79" />
              <div className="text-center" data-id="element-80">
                <p className="font-semibold text-gray-900 text-lg mb-1" data-id="element-81">
                  LinkedIn
                </p>
                <a href="https://www.linkedin.com/in/jacob-j-jackson/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline text-lg" data-id="element-82">
                  linkedin.com/in/jacob-j-jackson
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}